"use client";
import { useContext } from "react";
import { StwContext } from "./StwInfoProvider.js";
const useStwContext = () => {
  const context = useContext(StwContext);
  if (!context) {
    throw new Error(
      "`useStwContext` must be used within a `StwInfoContextProvider`"
    );
  }
  return context;
};
export {
  useStwContext
};
